/** Check if NIPSYS extension is installed (injected by content script) */
export function isExtensionInstalled(): boolean {
  return !!(window as any).__NIPSYS_EXTENSION_INSTALLED__;
}

/** Send a message to the extension and listen for the response */
export function sendExtensionRequest(action: string, payload: Record<string, any>): { requestId: string; promise: Promise<any> } {
  const requestId = crypto.randomUUID();
  
  const promise = new Promise<any>((resolve, reject) => {
    const timeout = setTimeout(() => {
      window.removeEventListener("message", handler);
      reject(new Error("Timeout: extensão não respondeu em 60s."));
    }, 60_000);

    function handler(event: MessageEvent) {
      if (event.source !== window) return;
      const d = event.data;
      if (d?.type === "NIPSYS_EXTENSION_RESPONSE" && d?.requestId === requestId) {
        clearTimeout(timeout);
        window.removeEventListener("message", handler);
        if (d.response?.success) {
          resolve(d.response);
        } else {
          reject(new Error(d.response?.error || "Erro desconhecido da extensão."));
        }
      }
    }

    window.addEventListener("message", handler);
  });

  window.postMessage({
    type: "NIPSYS_EXTENSION_REQUEST",
    action,
    payload: {
      ...payload,
      // Auth coordenada /extension/*: o service worker da extensão não tem
      // acesso ao localStorage do web app, então CADA mensagem relayada carrega
      // o JWT atual. A extensão persiste o token e o anexa como header
      // Authorization nas chamadas a /extension/* (Mode A on-demand + Mode B
      // poll entre sessões da página).
      authToken: localStorage.getItem("token") || undefined,
    },
    requestId,
  }, "*");

  return { requestId, promise };
}
